import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { ReactComponent as IconChevronLeft } from "@Icons/16x16/chevron-left.svg";
import { Upsell, UpsellIdentifiers } from "@Types/upsells";
import { getFormattedTotalPrice, isSelected } from "@Utils/upsells";
import UpsellItemMobile from "./UpsellItemMobile";
import "./style.scss";

interface Props {
  hideUpsells: () => void;
  onSelectUpsell: (selectedUpsells: UpsellIdentifiers) => void;
  onSubmit: () => void;
  onSubmitWithoutUpsell: () => void;
  onUnselectUpsell: (selectedUpsells: UpsellIdentifiers) => void;
  selectedUpsellsTags: UpsellIdentifiers[];
  upsells: Upsell[];
}

const UpsellsMobile: FunctionComponent<Props> = ({
  hideUpsells,
  onSelectUpsell,
  onSubmit,
  onSubmitWithoutUpsell,
  onUnselectUpsell,
  selectedUpsellsTags,
  upsells,
}) => {
  const intl = useIntl();

  return (
    <div className="UpsellsMobile">
      <div className="UpsellsMobile-navigation">
        <div className="UpsellsMobile-navigation-back" onClick={() => hideUpsells()}>
          <IconChevronLeft />
        </div>
        <div className="UpsellsMobile-navigation-title">
          {intl.formatMessage({ id: "cheerz_UpsellsModal_title" })}
        </div>
      </div>

      <div className="UpsellsMobile-options">
        {upsells.map((upsell) => {
          const isUpsellSelected = isSelected(upsell.tag, upsell.value, selectedUpsellsTags);
          return (
            <UpsellItemMobile
              isSelected={isUpsellSelected}
              key={`${upsell.tag}-${upsell.value}`}
              onSelectChange={() =>
                isUpsellSelected ? onUnselectUpsell(upsell) : onSelectUpsell(upsell)
              }
              upsell={upsell}
            />
          );
        })}
      </div>
      <div className="UpsellsMobile-bottom">
        {selectedUpsellsTags.length > 0 ? (
          <ButtonSmily onClick={() => onSubmit()} size="s" type="primary">
            {intl.formatMessage(
              { id: "cheerz_UpsellsModal_button__with_upsell" },
              { totalPrice: getFormattedTotalPrice(upsells, selectedUpsellsTags, intl) }
            )}
          </ButtonSmily>
        ) : (
          <ButtonSmily onClick={onSubmitWithoutUpsell} size="s" type="primary">
            {intl.formatMessage({ id: "cheerz_UpsellsModal_button__without_upsell" })}
          </ButtonSmily>
        )}
      </div>
    </div>
  );
};

export default UpsellsMobile;
